export const BusinessPartnersModuleTranslations: Array<string> = [
    // title
    'xmlBusinessPartner',
    'xmlBusinessPartnersFunctions',
    'Admin.Msg.EditTitle',
    'AddEditBusinessPartners.BusinessPartners',
    'Admin.BusinessPartners.AddNewBusinessPartners',
    'Admin.AddEditBusinessPartner.CreateNew',
    'Admin.AddEditBusinessPartner.LabelGroupName',
    'xmlBusinessPartners',
    'Admin.BusinessPartners.BlockedFromDeletionInfo',
    'xmlBusinessPartnerCustomFields',
    'xmlBusinessPartnerPermissions',
    'xmlBusinessPartnerRelationships',
    'Admin.BusinessPartners.AddNewBusinessPartnerCustomFields',

    // add-edit screen
    'Admin.AddEditBusinessPartner.LabelExternalId',
    'Admin.AddEditBusinessPartner.FirstName',
    'Admin.AddEditBusinessPartner.LastName',
    'Admin.AddEditBusinessPartner.Email',
    'Admin.AddEditBusinessPartner.Telephone',
    'Admin.AddEditBusinessPartner.LabelAddress1',
    'Admin.AddEditBusinessPartner.LabelAddress2',
    'Admin.AddEditBusinessPartner.LabelCity',
    'Admin.AddEditBusinessPartner.LabelRegion',
    'Admin.AddEditBusinessPartner.LabelCountry',
    'Admin.AddEditBusinessPartner.LabelState',
    'Admin.AddEditBusinessPartner.LabelTimeZone',
    'Admin.AddEditBusinessPartner.Fax',
    'Admin.AddEditBusinessPartner.LabelVATNumber',
    'Admin.AddEditBusinessPartner.LabelTaxNumber1',
    'Admin.AddEditBusinessPartner.LabelTaxNumber2',
    'Admin.AddEditBusinessPartner.LabelBankAccount1',
    'Admin.AddEditBusinessPartner.LabelBankAccount2',
    'Admin.AddEditBusinessPartner.LabelBusinessPartnerType',
    'Admin.AddEditBusinessPartner.LabelPrimaryIndustry',
    'Admin.AddEditBusinessPartner.AddressName',
    'Admin.AddEditBusinessPartner.AddressAdditionalName',
    'Admin.AddEditBusinessPartner.AddressName3',
    'Admin.AddEditBusinessPartner.AddressName4',
    'Admin.AddEditBusinessPartner.FormOfAddress',
    'Admin.AddEditBusinessPartner.TaxJurisdiction',
    'Admin.AddEditBusinessPartner.CorrespondenceLanguage',
    'Admin.AddEditBusinessPartner.MobilePhone',
    'Admin.AddEditBusinessPartner.District',
    'Admin.AddEditBusinessPartner.POBoxPostalCode',
    'Admin.AddEditBusinessPartner.POBox',
    'Admin.AddEditBusinessPartner.StreetName',
    'Admin.AddEditBusinessPartner.HouseNumber',
    'Admin.AddEditBusinessPartner.TransportZone',
    'Admin.AddEditBusinessPartner.StreetPrefixName',
    'Admin.AddEditBusinessPartner.AdditionalStreetPrefixName',
    'Admin.AddEditBusinessPartner.StreetSuffixName',
    'Admin.AddEditBusinessPartner.AdditionalStreetSuffixName',
    'Admin.BusinessPartner.ContactInfoSection',
    'Admin.BusinessPartner.AddressSection',
    'Admin.BusinessPartner.AdditionalInfoSection',
    'Admin.BusinessPartner.GeneralInfoSection',
    'Admin.BusinessPartner.StatusSection',
    'Admin.AddEditBusinessPartner.BillingBlock',
    'Admin.AddEditBusinessPartner.DeliveryBlock',
    'Admin.AddEditBusinessPartner.SalesOrderBlock',
    'Admin.BusinessPartnerType.Organization',
    'Admin.BusinessPartnerType.Person',
    'BusinessPartners.BusinessPartnerId',
    'Admin.BusinessPartners.Permissions',
    'Admin.AddEditBusinessPartnerFunction.TranslationLabel',
    'Admin.AddEditBusinessPartnerFunction.Translate',
    'Admin.SelectLanguage',
    'BusinessPartnerFunction.ValidFromGreaterThanValidTo',
    'Admin.BusinessPartnerFunction.KeyPlaceholder',
    'Admin.AddEditBusinessPartner.LabelPartnerId',
    'Admin.AddEditBusinessPartner.Phone',
    'Admin.AddEditBusinessPartner.LabelPostalCode',
    'Admin.AddEditBusinessPartner.Country',
    'Admin.BusinessPartner.PhysicalAddressSection',
    'Admin.BusinessPartners.StateSearchConditionMessage',


    // datatable columns
    'Admin.Controls.Properties.ExternalId',
    'xsltFirstName',
    'xsltLastName',
    'xsltCountry',
    'Admin.AddEditUser.State',
    'Admin.BusinessPartners.Region',
    'xsltCity',
    'Admin.AddEditUser.ZipCode',
    'Admin.market_defn.MarketTimeZone',
    'Msg.Address1',
    'Msg.Address2',
    'xsltEMail',
    'xsltPhone',
    'Admin.BusinessPartners.VATNumber',
    'Admin.BusinessPartners.TaxNumber1',
    'Admin.BusinessPartners.TaxNumber2',
    'Msg.Fax',
    'Admin.BusinessPartners.BankAccount1',
    'Admin.BusinessPartners.BankAccount2',
    'Admin.BusinessPartners.CreditCardNumber1',
    'Admin.BusinessPartners.CreditCardNumber2',
    'Admin.BusinessPartners.CreditCardExpirationDate1',
    'Admin.BusinessPartners.CreditCardExpirationDate2',
    'Admin.BusinessPartners.CreditCardHolderName1',
    'Admin.BusinessPartners.CreditCardHolderName2',
    'Admin.BusinessPartners.PrimaryIndustry',
    'Admin.BusinessPartners.BusinessPartnerType',
    'Admin.BusinessPartners.AddNew',
    'Admin.BusinessPartnerList.QuickSearch',
    'Admin.BusinessPartnerList.TotalBusinessPartners',
    'Admin.MLDictItems.Key',
    'Admin.CertificateManagement.ValidFrom',
    'Admin.CertificateManagement.ValidTo',
    'Admin.BusinessPartnerFunction.AddNew',
    'Admin.BusinessPartnerFunctionList.QuickSearch',
    'Admin.BusinessPartnerFunctionList.TotalBusinessPartnersFunctions',
    'Admin.BusinessPartnerFunction.isMandatory',
    'Admin.BusinessPartnerFunction.isUnique',
    'Admin.Add_Edit_OrderStatus.Default',
    'Admin.SuccessfullyDeleted',
    'Admin.BulkBusinessPartnerDeletion.DeleteMessageDialogNoBusinessPartnersSelected',
    'Admin.BulkBusinessPartnerDeletion.DeleteMessageDialog',
    'Admin.BulkBusinessPartnerDeletion.CannotDeleteBlocked',
    'Admin.BulkBusinessPartnerDeletion.SelectBusinessPartner',
    'Admin.BulkBusinessPartnerDeletion.SelectAll',
    'xsltName2',
    'xsltName3',
    'xsltName4',

    // Add edit business partner custom field
    'Admin.AddEditBusinessPartnerCustomField.Name',
    'Admin.AddEditBusinessPartnerCustomField.Label',
    'Admin.AddEditBusinessPartnerCustomField.Type',
    'Admin.AddEditBusinessPartnerCustomField.Attribute',
    'Admin.AddEditBusinessPartnerCustomField.PerosnalData',
    'Admin.AddEditBusinessPartnerCustomField.SensitiveData',
    'Admin.AddEditBusinessPartnerCustomField.EditableOnQuote',
    'Admin.BusinessPartnerCustomField.AddNew',
    'Admin.AddEditBusinessPartnerCustomField.TranslationLabel',
    'Admin.AddEditBusinessPartnerCustomField.LabelGroupName',
    'Admin.AddEditBusinessPartnerCustomField.Translate',
    'Admin.QPEdit.Hidden',
    'Admin.QPEdit.ReadDashOnly',
    'CustomerFieldsPermissions.Editable',
    'Admin.UserCustomField.FieldPermission',
    'Admin.BusinessPartnerCustomField.SameForAll',
    'Admin.AddEditBusinessPartnerCustomField.BooleanTypeDeletionDescription',
    'Admin.BusinessPartnerCustomFieldType.Boolean',
    'Admin.BusinessPartnerCustomFieldType.Attribute',
    'Admin.BusinessPartnerCustomFieldType.Date',
    'Admin.BusinessPartnerCustomFieldType.Number',
    'Admin.BusinessPartnerCustomFieldType.Text',

    //Business Partner Permission List Page
    'Admin.BusinessPartnerPermissionList.AddNew',
    'Admin.BusinessPartnerPermissionList.QuickSearch',
    'Admin.BusinessPartnerPermissionList.Active',
    'Admin.BusinessPartnerPermissionList.RuleName',
    'xmlBusinessPartnerPermissions',
    'AddCategory.Title2',
    'Admin.Pricebooks.VisibilityConditions',
    'xsltAllBusinessPartnersAreVisibleToSelectedGroups',
    'BusinessPartner.Permissions.AllVisible',
    'Admin.AddEditBusinessPartnerPermission.CreateNew',
    'BusinessPartner.Permissions.StateAbbreviation',
    'BusinessPartner.Permissions.CountryAbbreviation',
    'Admin.BusinessPartner.Permission.Operator',
    'BusinessPartner.Permissions.ValueOfBoolField',
    'BusinessPartner.Name',
    'BusinessPartner.Country',
    'BusinessPartner.Permissions.FieldType',
    'BusinessPartner.Permissions.SystemFields',
    'BusinessPartner.Permissions.CustomFields',
    'BusinessPartner.Permissions.OperatorEquals',
    'BusinessPartner.Permissions.OperatorNotEquals',
    'BusinessPartner.Permissions.OperatorContains',
    'BusinessPartner.Permissions.OperatorBeginsWith',
    'BusinessPartner.Permissions.Address1',
    'BusinessPartner.Permissions.PartnerId',
    'BusinessPartner.Permissions.ExternalId',
    'BusinessPartner.Permissions.CustomFieldValue',
    'BusinessPartner.Permissions.Value',

    //Business Partner Relationships
    'Admin.AddEditBusinessPartnerRelationship.CreateNew',
    'Admin.AddEditBusinessPartnerRelationship.Code',
    'Admin.AddEditBusinessPartnerRelationship.Name',
    'Admin.AddEditBusinessPartnerRelationship.IsTwoWay',
    'Admin.AddEditBusinessPartnerRelationship.Description1',
    'Admin.AddEditBusinessPartnerRelationship.Description2',
    'Admin.BusinessPartnerRelationshipList.SelectBusinessPartnerFunction',
    'Admin.BusinessPartnerRelationshipList.BusinessPartnerFunctionInfoIcon',
    'Admin.BusinessPartnerRelationshipList.Code',
    'Admin.BusinessPartnerRelationshipList.Name',
    'Admin.BusinessPartnerRelationshipList.Description',
    'Admin.BusinessPartnerRelationshipList.QuickSearch',
  'Admin.BusinessPartnerRelationshipList.BusinessPartnerFunctionSuccessfullyUpdated',
    'Admin.AddEditBusinessPartnerRelationship.CodeInfo',
    'Admin.AddEditBusinessPartner.Relationships',
    'Admin.BusinessPartnerRelationship.CategoryCode',
    'Admin.BusinessPartnerRelationship.Description',
    'Admin.BusinessPartnerRelationship.BpName',
    'Admin.BusinessPartnerRelationship.QuickSearch',
    'Admin.BusinessPartnerRelationship.AddNewRelationship',
    'Admin.BusinessPartnerRelationship.SelectRelationship',
    'Admin.BusinessPartnerRelationship.SelectBusinessPartnerName',
    'Admin.BusinessPartnerRelationship.DeleteRelationshipFor',
    'Admin.BusinessPartnerRelationship.DeleteRelationship',
    'Admin.BusinessPartnerRelationshipTranslation.Column.Label',
    'Admin.BusinessPartnerRelationshipTranslation.Column.DefaultLanguage',
    'Admin.BusinessPartnerRelationshipTranslation.RelationshipInfo',
    'Admin.BusinessPartnerRelationshipTranslation.RelationshipInfo.Name',
    'Admin.BusinessPartnerRelationshipTranslation.RelationshipInfo.Description1',
    'Admin.BusinessPartnerRelationshipTranslation.RelationshipInfo.Description2',
    'Admin.BusinessPartnerRelationshipTranslation.SelectLanguage',
    'Admin.BusinessPartnerRelationshipTranslation.TitleTranslation',
    'Admin.BusinessPartnerRelationship.IsDefault',

    //Business Partner Statuses
    'xmlBusinessPartnerStatuses',
    'Admin.BusinessPartnerStatuses.AddNew',
    'Admin.BusinessPartnerStatuses.Code',
    'Admin.BusinessPartnerStatuses.Description',
    'Admin.BusinessPartnerStatuses.PartnerFunction',
    'Admin.BusinessPartnerStatuses.Type',
    'Admin.BusinessPartnerStatusConfigurationType.Warning',
    'Admin.BusinessPartnerStatusConfigurationType.Error',
    'Admin.BusinessPartnerStatuses.TranslationLabel',
    'Admin.BusinessPartnerStatuses.Translate',
    'Admin.BusinessPartnerStatuses.QuickSearch',
    'Admin.BusinessPartnerStatuses.TotalCount',

    //Business Partner Standard Fields
    'Admin.BusinessPartnerStandardFieldType.Text',
    'Admin.BusinessPartnerStandardFieldType.Number',
    'xmlBusinessPartnerFields',
    'xmlBusinessPartnerStandardFields',
    'BusinessPartnerStandardFields.SetPermission',
    'BusinessPartnerStandardFields.QuickSearch',

    // Business Partner Sales Area
    'Admin.BusinessPartnerSalesArea.SalesArea',
    'Admin.BusinessPartnerSalesArea.QuickSearch',
    'Admin.BusinessPartnerSalesArea.SalesOrg',
    'Admin.BusinessPartnerSalesArea.DistributionChannel',
    'Admin.BusinessPartnerSalesArea.Division',
    'Admin.BusinessPartnerSalesArea.SalesOffice',
    'Admin.BusinessPartnerSalesArea.Currency',
    'Admin.BusinessPartnerSalesArea.SalesGroup',
    'Admin.BusinessPartnerSalesArea.CustomerGroup',
    'Admin.BusinessPartnerSalesArea.CustomerPriceGroup',
    'Admin.BusinessPartnerSalesArea.ShippingConditions',
    'Admin.BusinessPartnerSalesArea.ExchangeRateType',
    'Admin.BusinessPartnerSalesArea.PPCustomerProcedure',
    'Admin.BusinessPartnerSalesArea.IncotermsLocation1',
    'Admin.BusinessPartnerSalesArea.Incoterms1',
    'Admin.BusinessPartnerSalesArea.PaymentTerms',
    'Admin.AddEditBusinessPartnerCustomField.IsSalesAreaRelevant'

];
